import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'

import './icons'
import './index.css'
import Routes from './Routes'
import store from './store'

render(
  <React.StrictMode>
    <Provider store={store}>
      <Routes />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)
